import React from 'react'

import Menu from '../menu'
import NavLogo from '../nav-logo'

export default () => {
  return (
    <div className="navigation">
      <div className="navigation__track">
        <div className="navigation__item">
          <Menu />
        </div>
        <div className="navigation__item">
          <NavLogo />
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/mobile/components/navigation/index.js